import {
  InsertDataAuth,
} from "../../Hooks/InsertData";
import {
  CREATE_CONTACT
} from "../type";

//create new user
export const createContactAction = (data) => async (dispatch) => {
  try {
    const response = await InsertDataAuth(`/api/contact-us/`, data);
    dispatch({
      type: CREATE_CONTACT,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: CREATE_CONTACT,
      payload: e.response,
    });
  }
};